import './ConsultarMOV.css'

import { ArrowDownTrayIcon } from '@heroicons/react/20/solid'
import { CloseCircleOutlined, SearchOutlined, ZoomOutOutlined, EyeOutlined, QuestionCircleOutlined, SyncOutlined, AndroidOutlined, AppleOutlined } from '@ant-design/icons'
import { Button, DatePicker, Drawer, Input, Pagination, Popconfirm, Select, Space, Spin, Switch, Table, Tooltip } from 'antd'
import moment from 'moment'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useAxiosTna } from '../../../hooks/useAxiosTna'
import { catGetCodUrl, movGetConUrl, movGetNumUrl, movGetSdocUrl, movGetSrinUrl, movGetStpoUrl, rctGrpRecurUrl, segConnUrl, tsk18Url, tsk7Url, tskRecuperarUrl, usuRcptEmsrUrl } from '../../../api/apiUrl'
import { configType } from '../../../types/configType'
import { notifyType } from '../../../types/notifyType'
import { msgType } from '../../../types/msgType'
import { setLastAccess } from '../../../utils/lstorageUtil'
import { formatAmount, formatDate, formatTime } from '../../../utils/formatUtil'
import { downloadFile, viewerFile } from '../../../utils/fileUtil'
import { NotifyRed } from '../../../components/Msg/NotifyRed'
import { NotifyGreen } from '../../../components/Msg/NotifyGreen'
import { NotifyYellow } from '../../../components/Msg/NotifyYellow'
import { SelRcptEmsr } from '../../../components/Panel/SelRcptEmsr'
import { AppFooter } from '../../../components/AppFooter'
import { DetalleRen } from '../../../components/Panel/Detail/DetalleRen'
import { DetalleSol } from '../../../components/Panel/Detail/DetalleSol'
import { DetalleOpe } from '../../../components/Panel/Detail/DetalleOpe'

var jszip = require('jszip')

export const ConsultarMOV = ({ page: { code: resource } }) => {
    const dvFechaIni = moment().startOf('month')
    const dvFechaFin = moment().endOf('month')
    const dvFecha = moment()

    const { axiosTnaGet, axiosTnaPost } = useAxiosTna()
    const notifyRedRef = useRef()
    const notifyGreenRef = useRef()
    const notifyYellowRef = useRef()
    const detRenRef = useRef()
    const detSolRef = useRef()
    const detOpeRef = useRef()
    const searchInput = useRef(null)
    const [loadPage, setLoadPage] = useState(true)
    const [loadTokenConn, setLoadTokenConn] = useState(true)
    const [loadRcptEmsr, setLoadRcptEmsr] = useState(true)
    const [loadTipoRen, setLoadTipoRen] = useState(true)
    const [loadTipoMov, setLoadTipoMov] = useState(true)
    const [loadData, setLoadData] = useState(false)
    const [loadConfigRT, setLoadConfigRT] = useState(false)
    const [loadBusqMov, setLoadBusqMov] = useState(false)
    const [loadTask7Add, setLoadTask7Add] = useState(false)
    const [loadTask7Down, setLoadTask7Down] = useState(false)
    const [loadTask18Add, setLoadTask18Add] = useState(false)
    const [loadTask18Down, setLoadTask18Down] = useState(false)
    const [allGroup, setAllGroup] = useState(false)
    const [receptores, setReceptores] = useState([])
    const [grupos, setGrupos] = useState([])
    const [tiposRem, setTiposRem] = useState([])
    const [tiposSol, setTiposSol] = useState([])
    const [tiposRen, setTiposRen] = useState([])
    const [tiposDoc, setTiposDoc] = useState([])
    const [tiposMov, setTiposMov] = useState([])
    const [tiposSal, setTiposSal] = useState([])
    const [selReceptor, setSelReceptor] = useState(null)
    const [selGrupo, setSelGrupo] = useState(null)
    const [dbSolicitud, setDbSolicitud] = useState(null)
    const [dbRendicion, setDbRendicion] = useState(null)
    const [dbOperacion, setDbOperacion] = useState(null)
    const [foFechaIni, setFoFechaIni] = useState(dvFechaIni)
    const [foFechaFin, setFoFechaFin] = useState(dvFechaFin)
    const [foFecha, setFoFecha] = useState(dvFecha)
    const [foTipoDoc, setFoTipoDoc] = useState(null)
    const [foTipoMov, setFoTipoMov] = useState(null)
    const [foTipoSal, setFoTipoSal] = useState(null)
    const [foRindente, setFoRindente] = useState(null)
    const [foNumMV, setFoNumMV] = useState(null)
    const [foSave, setFoSave] = useState(null)
    const [movimientos, setMovimientos] = useState([])
    const [saldosDoc, setSaldosDoc] = useState([])
    const [saldosRin, setSaldosRin] = useState([])
    const [saldosTpo, setSaldosTpo] = useState([])
    const [selMovimiento, setSelMovimiento] = useState(null)
    const [ordenMov, setOrdenMov] = useState(false)
    const [mvTotalDocuments, setMvTotalDocuments] = useState(0)
    const [mvPageSize, setMvPageSize] = useState(10)
    const [mvCurrentPage, setMvCurrentPage] = useState(1)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [, setSelectedRows] = useState([])
    const [openDrawer, setOpenDrawer] = useState(false)
    const [taskInterval, setTaskInterval] = useState(false)
    const [task7, setTask7] = useState({ task: null, id: null, first: true })
    const [task18, setTask18] = useState({ task: null, id: null, first: true })

    useEffect(() => {
        setLoadPage(loadTokenConn || loadRcptEmsr || loadTipoRen || loadTipoMov)
    }, [loadTokenConn, loadRcptEmsr, loadTipoRen, loadTipoMov])

    useEffect(() => {
        setLoadData(loadConfigRT || loadBusqMov || loadTask7Add || loadTask7Down || loadTask18Add || loadTask18Down)
    }, [loadConfigRT, loadBusqMov, loadTask7Add, loadTask7Down, loadTask18Add, loadTask18Down])

    useEffect(() => {
        setDbSolicitud(selMovimiento && selMovimiento.solRen ? { numSO: selMovimiento.numMV } : null)
        setDbRendicion(selMovimiento && (!selMovimiento.solRen || (selMovimiento.origen && !selMovimiento.origen.opeRen)) ? { numRD: (!selMovimiento.solRen ? selMovimiento.numMV : selMovimiento.origen.numRD) } : null)
        setDbOperacion(selMovimiento && selMovimiento.origen && selMovimiento.origen.opeRen ? { id: selMovimiento.origen.origenID } : null)
    }, [selMovimiento])

    useEffect(() => {
        const tdoc = tiposSol.map((p => ({ codigo: p.reqCode, nombre: p.reqName })))
        if (tiposRem && tiposRem.length > 0)
            tiposRem.forEach(p => {
                tdoc.push({ codigo: p.rendCode, nombre: p.rendName })
            })
        else
            tiposRen.filter(p => p.bool1 === false).forEach(p => {
                tdoc.push(p)
            })
        setTiposDoc(tdoc)
        setFoTipoDoc(null)
    }, [tiposRem, tiposSol, tiposRen])

    useEffect(() => {
        const tipos = [
            { codigo: '1', nombre: 'Movimiento' },
            { codigo: '2', nombre: 'S. Documento' },
            { codigo: '3', nombre: 'S. Rindente' },
            { codigo: '4', nombre: 'S. Tipo Doc' }]
        const tipo = tipos.find(() => true)?.codigo
        setTiposSal(tipos)
        setFoTipoSal(tipo)
    }, [])

    useEffect(() => {
        let isMounted = true

        const tokenConn = async () => {
            const url = segConnUrl()
            await axiosTnaGet(url)
            isMounted && setLoadTokenConn(false)
        }

        tokenConn()

        return () => {
            isMounted = false
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        let isMounted = true

        const rcptEmsr = async () => {
            const url = usuRcptEmsrUrl(resource)
            const [data, err] = await axiosTnaGet(url)

            if (data)
                isMounted && setReceptores(data.rcpt)
            if (err)
                notifyRedRef.current.handleOpen(err, notifyType.error)

            isMounted && setLoadRcptEmsr(false)
        }

        const catTipoRen = async () => {
            const url = catGetCodUrl(configType.catTipoRen)
            const [data, err] = await axiosTnaGet(url)

            if (data)
                isMounted && setTiposRen(data.detalle)
            if (err)
                notifyRedRef.current.handleOpen(err, notifyType.error)

            isMounted && setLoadTipoRen(false)
        }

        const catTipoMov = async () => {
            const url = catGetCodUrl(configType.catTipoMov)
            const [data, err] = await axiosTnaGet(url)

            if (data)
                isMounted && setTiposMov(data.detalle?.filter(p => !p.string1) || [])
            if (err)
                notifyRedRef.current.handleOpen(err, notifyType.error)

            isMounted && setLoadTipoMov(false)
        }

        if (!loadTokenConn) {
            rcptEmsr()
            catTipoRen()
            catTipoMov()
        }

        return () => {
            isMounted = false
        }
        // eslint-disable-next-line
    }, [loadTokenConn])

    useEffect(() => {
        let isMounted = true

        const t7Get = async () => {
            const url = tsk7Url()
            const [data, err] = await axiosTnaGet(url)

            if (data)
                isMounted && setTask7(prev => ({
                    ...prev,
                    task: data.data,
                    id: data.data?.id ?? prev.id,
                    first: false
                }))
            if (err)
                console.log(`Task: ${err.message}`)
        }

        const t18Get = async () => {
            const url = tsk18Url()
            const [data, err] = await axiosTnaGet(url)

            if (data)
                isMounted && setTask18(prev => ({
                    ...prev,
                    task: data.data,
                    id: data.data?.id ?? prev.id,
                    first: false
                }))
            if (err)
                console.log(`Task: ${err.message}`)
        }

        if (!loadTokenConn) {
            if (task7.first || (!task7.task && task7.id) || (task7.task && !task7.task.complete))
                t7Get()
            if (task18.first || (!task18.task && task18.id) || (task18.task && !task18.task.complete))
                t18Get()
        }

        return () => {
            isMounted = false
        }
        // eslint-disable-next-line
    }, [taskInterval, loadTokenConn])

    useEffect(() => {
        let isMounted = true

        const interval = setInterval(() => {
            isMounted && setTaskInterval(prev => !prev)
        }, 5000)

        return () => {
            clearInterval(interval)
            isMounted = false
        }
    }, [])

    const setConfigRT = useCallback(async (person) => {
        if (!person) {
            setTiposSol([])
            setTiposRem([])
            return
        }

        setLoadConfigRT(true)

        const url = rctGrpRecurUrl(person.rcptRUC, allGroup ? '' : person.ruc, resource)
        const [data, err] = await axiosTnaGet(url)

        if (data) {
            const { success, data: config } = data
            if (success) {
                setTiposSol(config.tiposSol || [])
                setTiposRem(config.tiposRen || [])
            }
        }
        if (err) {
            setTiposSol([])
            setTiposRem([])
            notifyRedRef.current.handleOpen(err, notifyType.error)
        }

        setLoadConfigRT(false)
        // eslint-disable-next-line
    }, [setTiposSol, setTiposRem])

    const getUsu = (usu) => {
        if (!usu)
            return ''
        else if (usu.docIdentidad)
            return (`${usu.docIdentidad.documento} - ${usu.docIdentidad.denominacion}`).toUpperCase()
        else
            return `${usu.userID} - ${usu.userName}`
    }

    const getMov = (mov, index = null) => {
        var nmov = { ...mov, key: mov.id, index }
        if (index === null)
            delete nmov.index
        return nmov
    }

    const getTitleDrawer = (mov) => {
        if (!mov || mov.isDet === null || mov.isDet === undefined || (mov.isDet !== 0 && !mov.origen))
            return ''
        else if (mov.isDet === 0 && mov.solRen)
            return `Solicitud ( ${mov.numMV} )`
        else if (mov.isDet === 0 && !mov.solRen)
            return `Rendición ( ${mov.numMV} )`
        else if (mov.isDet === 1 && mov.origen.opeRen)
            return `Operación ( ${mov.numMV} )`
        else if (mov.isDet === 1 && !mov.origen.opeRen)
            return `Rendición ( ${mov.origen.numRD ?? mov.numMV} )`
        else
            return ''
    }

    const clearFiltroMV = (all = true) => {
        if (all) {
            setFoSave(null)
            setMovimientos([])
            setMvTotalDocuments(0)
        }
        setSelMovimiento(null)
        setSelectedRows([])
        setSelectedRowKeys([])
    }

    const handleCloseDrawer = () => {
        setOpenDrawer(false)
        setSelMovimiento(null)
    }

    const handleSelReceptor = useCallback((person) => {
        setSelReceptor(person)
        let a_grupos = []
        if (person && person.grupo.length > 0)
            a_grupos = person.grupo.map(p => ({ ...p, ruc: p.grpCode, name: p.grpItem, rcptRUC: person.ruc }))
        setGrupos(a_grupos)
        clearFiltroMV()
    }, [setSelReceptor])

    const handleSelGrupo = useCallback((person) => {
        setSelGrupo(person)
        setConfigRT(person)
        clearFiltroMV()
    }, [setSelGrupo, setConfigRT])

    const handleBuscarMV = async (isCon) => {
        let err = null
        let data = null

        if (!selReceptor)
            err = {
                message: msgType.selectReceptor,
                oops: false
            }
        else if (!selGrupo && !allGroup)
            err = {
                message: msgType.selectGrupo,
                oops: false
            }
        else if (isCon && (!foFechaIni || !foFechaFin))
            err = {
                message: msgType.selectFecha,
                oops: false
            }
        else if (!isCon && !foNumMV)
            err = {
                message: msgType.inputNumMV,
                oops: false
            }

        if (err) {
            notifyYellowRef.current.handleOpen(err, notifyType.warning)
            return
        }

        setLoadBusqMov(true)

        const grupo = allGroup ? '' : selGrupo.ruc
        const fechaIni = foFechaIni ? (foFechaIni.format().split('T')[0] + 'T00:00:00') : ''
        const fechaFin = foFechaFin ? (foFechaFin.format().split('T')[0] + 'T00:00:00') : ''
        const tipoDoc = foTipoDoc || ''
        const tipoMov = foTipoMov || ''
        const rindente = foRindente || ''
        const numMV = foNumMV || ''

        const url = isCon ?
            movGetConUrl(selReceptor.ruc, grupo, fechaIni, fechaFin, tipoDoc, tipoMov, rindente, resource, ordenMov, 1, mvPageSize) :
            movGetNumUrl(selReceptor.ruc, numMV, 1, mvPageSize)
        const [data_api, err_api] = await axiosTnaGet(url)
        data = data_api
        err = err_api

        if (data) {
            const { totalDocuments, data: movs } = data
            if (!isCon && !allGroup && movs.find(p => p.grpCode !== selGrupo.ruc)) {
                setMovimientos([])
                setMvTotalDocuments(0)
            }
            else {
                setMovimientos(movs.map((mov, index) => getMov(mov, index)))
                setMvTotalDocuments(totalDocuments)
            }
            setMvCurrentPage(1)
            clearFiltroMV(false)
            setFoSave({
                svSelReceptor: selReceptor,
                svGrupo: grupo,
                svFechaIni: fechaIni,
                svFechaFin: fechaFin,
                svTipoDoc: tipoDoc,
                svTipoMov: tipoMov,
                svRindente: rindente,
                svOrdenMov: ordenMov,
                svNumMV: numMV,
                svIsCon: isCon,
            })
        }
        if (err)
            notifyRedRef.current.handleOpen(err, notifyType.error)

        setLoadBusqMov(false)
        setLastAccess()
    }

    const handleChangePagMV = async (page, pageSize) => {
        if (!foSave)
            return

        const { svSelReceptor, svGrupo, svFechaIni, svFechaFin, svTipoDoc, svTipoMov, svRindente, svOrdenMov, svNumMV, svIsCon } = foSave

        let err = null
        let data = null

        setLoadBusqMov(true)

        const url = svIsCon ?
            movGetConUrl(svSelReceptor.ruc, svGrupo, svFechaIni, svFechaFin, svTipoDoc, svTipoMov, svRindente, resource, svOrdenMov, page, pageSize) :
            movGetNumUrl(svSelReceptor.ruc, svNumMV, page, pageSize)
        const [data_api, err_api] = await axiosTnaGet(url)
        data = data_api
        err = err_api

        if (data) {
            const { totalDocuments, data: movs } = data
            setMovimientos(movs.map((mov, index) => getMov(mov, index)))
            setMvTotalDocuments(totalDocuments)
            setMvCurrentPage(page)
            clearFiltroMV(false)
        }
        if (err)
            notifyRedRef.current.handleOpen(err, notifyType.error)

        setLoadBusqMov(false)
        setLastAccess()
    }

    const handleBuscarSD = async (tpoSal) => {
        let err = null
        let data = null

        if (!selReceptor)
            err = {
                message: msgType.selectReceptor,
                oops: false
            }
        else if (!selGrupo && !allGroup)
            err = {
                message: msgType.selectGrupo,
                oops: false
            }
        else if (!foFecha)
            err = {
                message: msgType.selectFecha1,
                oops: false
            }

        if (err) {
            notifyYellowRef.current.handleOpen(err, notifyType.warning)
            return
        }

        setLoadBusqMov(true)

        const grupo = allGroup ? '' : selGrupo.ruc
        const fecha = foFecha.format().split('T')[0] + 'T00:00:00'
        const tipoDoc = foTipoDoc || ''
        const rindente = foRindente || ''

        const url = tpoSal === '2' ? movGetSdocUrl(selReceptor.ruc, grupo, fecha, tipoDoc, rindente, resource) :
            (tpoSal === '3' ? movGetSrinUrl(selReceptor.ruc, grupo, fecha, rindente, resource) :
                movGetStpoUrl(selReceptor.ruc, grupo, fecha, resource))
        const [data_api, err_api] = await axiosTnaGet(url)
        data = data_api
        err = err_api

        if (data) {
            const { data: movs } = data
            const sdos = movs.map((mov, index) => getMov({ ...mov, id: index }, index))
            tpoSal === '2' && setSaldosDoc(sdos)
            tpoSal === '3' && setSaldosRin(sdos)
            tpoSal === '4' && setSaldosTpo(sdos)
            clearFiltroMV(false)
        }
        if (err)
            notifyRedRef.current.handleOpen(err, notifyType.error)

        setLoadBusqMov(false)
        setLastAccess()
    }

    const handleDetalleMov = (record, isDet) => {
        const mov = { ...record, isDet }
        setSelMovimiento(mov)
        setOpenDrawer(true)
    }

    const handleTask7_Add = async () => {
        let err = null
        let data = null

        if (!selReceptor)
            err = {
                message: msgType.selectReceptor,
                oops: false
            }
        else if (!selGrupo && !allGroup)
            err = {
                message: msgType.selectGrupo,
                oops: false
            }
        else if (!foFechaIni || !foFechaFin)
            err = {
                message: msgType.selectFecha,
                oops: false
            }

        if (err) {
            notifyYellowRef.current.handleOpen(err, notifyType.warning)
            return
        }

        setLoadTask7Add(true)

        const grupo = allGroup ? '' : selGrupo.ruc
        const fechaIni = foFechaIni.format().split('T')[0] + 'T00:00:00'
        const fechaFin = foFechaFin.format().split('T')[0] + 'T00:00:00'
        const tipoDoc = foTipoDoc || ''
        const tipoMov = foTipoMov || ''
        const rindente = foRindente || ''

        const url = tsk7Url()
        const [data_api, err_api] = await axiosTnaPost(url, { rcptNumDoc: selReceptor.ruc, grupo, fechaIni, fechaFin, tipoDoc, tipoMov, rindente, resource, sort: ordenMov })
        data = data_api
        err = err_api

        if (data) {
            setTask7(prev => ({ ...prev, task: null, id: data.id }))
            notifyGreenRef.current.handleOpen({
                message: msgType.fileRequest,
                oops: false
            }, notifyType.success)
        }
        if (err)
            notifyRedRef.current.handleOpen(err, notifyType.error)

        setLoadTask7Add(false)
        setLastAccess()
    }

    const handleTask7_Down = async ({ id, file: record }) => {
        let err = null

        setLoadTask7Down(true)

        const url = tskRecuperarUrl(id)
        const [data, err_api] = await axiosTnaGet(url)
        err = err_api

        if (data) {
            try {
                const { document } = data
                const zip = new jszip()
                const zresult = await zip.loadAsync(document, { base64: true })
                const unzip = await zresult.file(record.fileName).async('base64')
                if (record.contentType === configType.contentTypePDF)
                    viewerFile(unzip, record.contentType, record.fileName)
                else
                    downloadFile(unzip, record.contentType, record.fileName)
                setTask7(prev => ({ ...prev, task: null, id: null }))
            }
            catch (error) {
                err = {
                    message: msgType.apiError,
                    detail: error.message,
                    oops: true
                }
            }
        }
        if (err)
            notifyRedRef.current.handleOpen(err, notifyType.error)

        setLoadTask7Down(false)
        setLastAccess()
    }

    const handleTask18_Add = async (tpoSal) => {
        let err = null
        let data = null

        if (!selReceptor)
            err = {
                message: msgType.selectReceptor,
                oops: false
            }
        else if (!selGrupo && !allGroup)
            err = {
                message: msgType.selectGrupo,
                oops: false
            }
        else if (!foFecha)
            err = {
                message: msgType.selectFecha1,
                oops: false
            }

        if (err) {
            notifyYellowRef.current.handleOpen(err, notifyType.warning)
            return
        }

        setLoadTask18Add(true)

        const grupo = allGroup ? '' : selGrupo.ruc
        const fecha = foFecha.format().split('T')[0] + 'T00:00:00'
        const tipoDoc = foTipoDoc || ''
        const rindente = foRindente || ''
        const tipoSal = tpoSal === '2' ? configType.tipoSal_NumDoc : (tpoSal === '3' ? configType.tipoSal_Rendidor : configType.tipoSal_CtaDoc)

        const url = tsk18Url()
        const [data_api, err_api] = await axiosTnaPost(url, { rcptNumDoc: selReceptor.ruc, grupo, fecha, tipoSal, tipoDoc, rindente, resource })
        data = data_api
        err = err_api

        if (data) {
            setTask18(prev => ({ ...prev, task: null, id: data.id }))
            notifyGreenRef.current.handleOpen({
                message: msgType.fileRequest,
                oops: false
            }, notifyType.success)
        }
        if (err)
            notifyRedRef.current.handleOpen(err, notifyType.error)

        setLoadTask18Add(false)
        setLastAccess()
    }

    const handleTask18_Down = async ({ id, file: record }) => {
        let err = null

        setLoadTask18Down(true)

        const url = tskRecuperarUrl(id)
        const [data, err_api] = await axiosTnaGet(url)
        err = err_api

        if (data) {
            try {
                const { document } = data
                const zip = new jszip()
                const zresult = await zip.loadAsync(document, { base64: true })
                const unzip = await zresult.file(record.fileName).async('base64')
                if (record.contentType === configType.contentTypePDF)
                    viewerFile(unzip, record.contentType, record.fileName)
                else
                    downloadFile(unzip, record.contentType, record.fileName)
                setTask18(prev => ({ ...prev, task: null, id: null }))
            }
            catch (error) {
                err = {
                    message: msgType.apiError,
                    detail: error.message,
                    oops: true
                }
            }
        }
        if (err)
            notifyRedRef.current.handleOpen(err, notifyType.error)

        setLoadTask18Down(false)
        setLastAccess()
    }

    const handleSearch = (selectedKeys, confirm, dataIndex) => confirm()
    const handleReset = (clearFilters, confirm) => { clearFilters(); confirm() }

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div style={{ padding: 8, }} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Ingrese palabra`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    className='text-xs'
                    style={{ marginBottom: 8, display: 'block', }}
                />
                <Space>
                    <Button className='flex items-center justify-center text-xs bg-indigo-600 border-indigo-600 text-white hover:bg-indigo-500 hover:border-indigo-600 hover:text-white focus:hover:bg-indigo-500 focus:hover:border-indigo-600 focus:hover:text-white'
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90, }}
                    >
                        Buscar
                    </Button>
                    <Button className='flex items-center justify-center text-xs bg-indigo-600 border-indigo-600 text-white hover:bg-indigo-500 hover:border-indigo-600 hover:text-white focus:hover:bg-indigo-500 focus:hover:border-indigo-600 focus:hover:text-white'
                        onClick={() => clearFilters && handleReset(clearFilters, confirm)}
                        size="small"
                        style={{ width: 90, }}
                    >
                        Reiniciar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
        ),
        onFilter: (value, record) => {
            if (dataIndex === 'numMV') {
                const { numMV } = record
                return numMV.toLowerCase().includes(value.toLowerCase())
            }
            else if (dataIndex === 'rindente') {
                const rindente = getUsu(record.rindente ?? record.solicitante)
                return rindente && rindente.toLowerCase().includes(value.toLowerCase())
            }
            else if (dataIndex === 'fechaMov') {
                const { fechaMov } = record
                const fecha = moment(fechaMov).format('DD/MM/yyyy')
                return fecha.includes(value.toLowerCase())
            }
            else
                return false
        },
    })

    const rowSelection = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys, newSelectedRows) => {
            setSelectedRowKeys(newSelectedRowKeys)
            setSelectedRows(newSelectedRows)
        },
        getCheckboxProps: (record) => ({
            disabled: false,
        }),
        type: 'radio',
    }

    const mvColumns = [
        {
            title: 'Nº Movimiento',
            dataIndex: 'numMV',
            render: (_, record) =>
                <div className='flex justify-between'>
                    <div className='flex items-center'>
                        <button
                            className='text-blue-600 w-full text-left'
                            onClick={() => handleDetalleMov(record, 0)}
                        >
                            <span>{record.numMV}</span>
                        </button>
                    </div>
                    {
                        record.origen && (record.solRen || record.origen.opeRen) &&
                        <div className='flex justify-end space-x-1'>
                            <Tooltip title={record.origen.opeRen ? 'Detalle de operación' : 'Detalle de rendición'} placement="right">
                                <button onClick={() => handleDetalleMov(record, 1)}>
                                    <EyeOutlined />
                                </button>
                            </Tooltip>
                        </div>
                    }
                </div>,
        },
        {
            title: 'Tipo Doc.',
            dataIndex: 'tipoDoc',
            width: 120,
        },
        {
            title: 'Tipo Mov.',
            dataIndex: 'tipoMov',
            width: 90,
        },
        {
            title: 'Fecha Mov.',
            dataIndex: 'fechaMov',
            width: 92,
            render: (_, record) => <span>{formatDate(record.fechaMov)}</span>
        },
        {
            title: '-$-',
            dataIndex: 'monedaISO',
            width: 50,
            align: 'center',
            onCell: (record, rowIndex) => ({
                onClick: event => {
                    if (selectedRowKeys && selectedRowKeys.length > 0 && selectedRowKeys[0] === record.id) {
                        setSelectedRowKeys([])
                        setSelectedRows([])
                    }
                },
            })
        },
        {
            title: 'Monto',
            dataIndex: 'monto',
            width: 90,
            align: 'right',
            render: (_, record) => <span>{formatAmount(record.monto)}</span>
        },
        {
            title: 'Saldo',
            dataIndex: 'saldo',
            width: 90,
            align: 'right',
            render: (_, record) => <span>{formatAmount(record.saldo)}</span>
        },
        {
            title: 'Fecha Reg.',
            dataIndex: 'fechaReg',
            width: 150,
            responsive: ['lg'],
            render: (_, record) => <span>{formatTime(record.fechaReg)}</span>
        },
        {
            title: 'Rindente',
            dataIndex: 'rindente',
            width: 340,
            responsive: ['xl'],
            render: (_, record) => <span>{`${allGroup ? (record.grpCode + ' ') : ''} ${getUsu(record.rindente ?? record.solicitante)}`}</span>
        },
    ]

    const sdColumns = [
        {
            title: 'Nº Movimiento',
            dataIndex: 'numMV',
            render: (_, record) =>
                <div className='flex justify-between'>
                    <div className='flex items-center'>
                        <button
                            className='text-blue-600 w-full text-left'
                            onClick={() => handleDetalleMov(record, 0)}
                        >
                            <span>{record.numMV}</span>
                        </button>
                    </div>
                </div>,
            ...getColumnSearchProps('numMV'),
        },
        {
            title: 'Rindente',
            dataIndex: 'rindente',
            width: 340,
            responsive: ['xl'],
            render: (_, record) => <span>{`${allGroup ? (record.grpCode + ' ') : ''} ${getUsu(record.rindente ?? record.solicitante)}`}</span>,
            ...getColumnSearchProps('rindente'),
        },
        {
            title: 'Tipo Doc.',
            dataIndex: 'tipoDoc',
            width: 120,
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) => a.tipoDoc.length - b.tipoDoc.length,
        },
        {
            title: 'Fecha Mov.',
            dataIndex: 'fechaMov',
            width: 110,
            render: (_, record) => <span>{formatDate(record.fechaMov)}</span>,
            ...getColumnSearchProps('fechaMov'),
        },
        {
            title: '-$-',
            dataIndex: 'monedaISO',
            width: 60,
            align: 'center',
            onCell: (record, rowIndex) => ({
                onClick: event => {
                    if (selectedRowKeys && selectedRowKeys.length > 0 && selectedRowKeys[0] === record.id) {
                        setSelectedRowKeys([])
                        setSelectedRows([])
                    }
                },
            }),
            sorter: (a, b) => (a.monedaISO > b.monedaISO ? 1 : -1),
        },
        {
            title: 'Saldo',
            dataIndex: 'saldo',
            width: 100,
            align: 'right',
            render: (_, record) => <span>{formatAmount(record.saldo)}</span>,
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) => a.saldo - b.saldo,
        },
    ]

    const srColumns = [
        {
            title: 'Rindente',
            dataIndex: 'rindente',
            render: (_, record) => <span>{`${allGroup ? (record.grpCode + ' ') : ''} ${getUsu(record.rindente ?? record.solicitante)}`}</span>,
            ...getColumnSearchProps('rindente'),
        },
        {
            title: 'Tipo Doc.',
            dataIndex: 'tipoDoc',
            width: 120,
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) => a.tipoDoc.length - b.tipoDoc.length,
        },
        {
            title: 'Fecha Mov.',
            dataIndex: 'fechaMov',
            width: 110,
            render: (_, record) => <span>{formatDate(record.fechaMov)}</span>,
            ...getColumnSearchProps('fechaMov'),
        },
        {
            title: '-$-',
            dataIndex: 'monedaISO',
            width: 60,
            align: 'center',
            onCell: (record, rowIndex) => ({
                onClick: event => {
                    if (selectedRowKeys && selectedRowKeys.length > 0 && selectedRowKeys[0] === record.id) {
                        setSelectedRowKeys([])
                        setSelectedRows([])
                    }
                },
            }),
            sorter: (a, b) => (a.monedaISO > b.monedaISO ? 1 : -1),
        },
        {
            title: 'Saldo',
            dataIndex: 'saldo',
            width: 100,
            align: 'right',
            render: (_, record) => <span>{formatAmount(record.saldo)}</span>,
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) => a.saldo - b.saldo,
        },
    ]

    const stColumns = [
        {
            title: 'Tipo Doc.',
            dataIndex: 'tipoDoc',
            render: (_, record) => <span>{`${allGroup ? (record.grpCode + ' ') : ''} ${record.tipoDoc}`}</span>,
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) => a.tipoDoc.length - b.tipoDoc.length,
        },
        {
            title: 'Fecha Mov.',
            dataIndex: 'fechaMov',
            width: 110,
            render: (_, record) => <span>{formatDate(record.fechaMov)}</span>,
            ...getColumnSearchProps('fechaMov'),
        },
        {
            title: '-$-',
            dataIndex: 'monedaISO',
            width: 60,
            align: 'center',
            onCell: (record, rowIndex) => ({
                onClick: event => {
                    if (selectedRowKeys && selectedRowKeys.length > 0 && selectedRowKeys[0] === record.id) {
                        setSelectedRowKeys([])
                        setSelectedRows([])
                    }
                },
            }),
            sorter: (a, b) => (a.monedaISO > b.monedaISO ? 1 : -1),
        },
        {
            title: 'Saldo',
            dataIndex: 'saldo',
            width: 120,
            align: 'right',
            render: (_, record) => <span>{formatAmount(record.saldo)}</span>,
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) => a.saldo - b.saldo,
        },
    ]

    return (
        <div className="bg-white flex flex-col flex-grow site-drawer-render-in-current-wrapper">
            <Drawer
                title={getTitleDrawer(selMovimiento)}
                placement="right"
                onClose={handleCloseDrawer}
                open={openDrawer}
                getContainer={false}
                style={{ position: 'absolute' }}
                bodyStyle={{ padding: 20, }}
                headerStyle={{ padding: 15, }}
                destroyOnClose={true}
                maskClosable={false}
                zIndex={5}
                width={720}
                closeIcon={<CloseCircleOutlined aria-hidden="true" className='text-blue-900' />}
                extra={
                    <Space>
                        <></>
                    </Space>
                }
            >
                {
                    selMovimiento ?
                        <>
                            {
                                selMovimiento.isDet === 0 ?
                                    <>
                                        {
                                            selMovimiento.solRen ?
                                                <DetalleSol ref={detSolRef} selReceptor={selReceptor} dbSolicitud={dbSolicitud} /> :
                                                <DetalleRen ref={detRenRef} selReceptor={selReceptor} dbRendicion={dbRendicion} />
                                        }
                                    </> :
                                    <>
                                        {
                                            selMovimiento.isDet === 1 && selMovimiento.origen ?
                                                <>
                                                    {
                                                        selMovimiento.origen.opeRen ?
                                                            <DetalleOpe ref={detOpeRef} selReceptor={selReceptor} dbOperacion={dbOperacion} /> :
                                                            <DetalleRen ref={detRenRef} selReceptor={selReceptor} dbRendicion={dbRendicion} />
                                                    }
                                                </> :
                                                <></>
                                        }
                                    </>
                            }
                        </> :
                        <></>
                }
            </Drawer>
            <NotifyRed ref={notifyRedRef} />
            <NotifyGreen ref={notifyGreenRef} />
            <NotifyYellow ref={notifyYellowRef} />
            {
                loadPage ?
                    <div className='my-5 flex justify-center'>
                        <Spin tip='Loading....' size='large' />
                    </div> :
                    <div className='flex-grow'>
                        <div className='bg-gray-200 flex justify-start items-center space-x-4 px-3 py-3 ant-common-titania'>
                            <SelRcptEmsr comboLabel="RECEPTOR" people={receptores} setPerson={handleSelReceptor} flex_basis='basis-96' />
                            {
                                !allGroup &&
                                <SelRcptEmsr comboLabel={selReceptor?.grpName ?? 'Grupo'} people={grupos} setPerson={handleSelGrupo} flex_basis='basis-96' />
                            }
                            <Switch checkedChildren="ALL" unCheckedChildren="ALL" checked={allGroup} onChange={setAllGroup} />
                        </div>

                        <div className='p-3 flex flex-col ant-common-titania'>
                            <div className="flex flex-row flex-wrap space-x-3 mb-3">
                                <div className="flex items-center text-sm text-indigo-700">
                                    {
                                        ((!task7.id || task7.task?.message) && (!task18.id || task18.task?.message)) ?
                                            <>
                                                {
                                                    !loadData ?
                                                        <Popconfirm
                                                            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                                                            title={`¿Confirma la operación?`}
                                                            onConfirm={() => { foTipoSal === '1' ? handleTask7_Add() : handleTask18_Add(foTipoSal) }}
                                                            placement="right"
                                                            okText="Sí"
                                                            cancelText="No"
                                                        >
                                                            <div className='flex items-center cursor-pointer'>
                                                                <ArrowDownTrayIcon className="mr-1.5 h-5 w-5 text-gray-600" aria-hidden="true" />
                                                                {`Descargar`}
                                                            </div>
                                                        </Popconfirm> :
                                                        <div className='flex items-center cursor-not-allowed'>
                                                            <ArrowDownTrayIcon className="mr-1.5 h-5 w-5 text-gray-600" aria-hidden="true" />
                                                            {
                                                                (loadTask7Add || loadTask18Add) &&
                                                                <svg aria-hidden="true" role="status" className="inline mr-2 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#00008B" />
                                                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                                                                </svg>
                                                            }
                                                            {`Descargar`}
                                                        </div>
                                                }
                                            </> :
                                            <>
                                                {
                                                    (task7.task?.file || task18.task?.file) ?
                                                        <div className='flex items-center text-xs'>
                                                            <Tooltip title="Descargar archivo" placement='right'>
                                                                <ArrowDownTrayIcon className="mr-1.5 h-5 w-5 text-gray-600" aria-hidden="true" />
                                                            </Tooltip>
                                                            {
                                                                (loadTask7Down || loadTask18Down) &&
                                                                <SyncOutlined spin className='mr-2' />
                                                            }
                                                            <button
                                                                className='text-blue-600'
                                                                disabled={loadData}
                                                                onClick={() => task7.task?.file ? handleTask7_Down(task7.task) : handleTask18_Down(task18.task)}
                                                            >
                                                                {task7.task?.file?.fileName ?? task18.task?.file?.fileName}
                                                            </button>
                                                        </div> :
                                                        <div className='flex items-center text-xs'>
                                                            <ArrowDownTrayIcon className="mr-1.5 h-5 w-5 text-gray-600" aria-hidden="true" />
                                                            <SyncOutlined spin className='mr-2' />
                                                            {`Preparando archivo`}
                                                        </div>
                                                }
                                            </>
                                    }
                                </div>
                                {
                                    (task7.task?.message || task18.task?.message) &&
                                    <div className='flex items-center'>
                                        <p className="text-xs text-red-700">
                                            {task7.task?.message ?? task18.task?.message}
                                        </p>
                                    </div>
                                }
                            </div>

                            <p className="text-xs text-gray-700 mb-2">
                                <span>{`Busca un ${foTipoSal === '1' ? 'movimiento' : 'saldo'} de solicitud de fondo o reembolso usando los filtros de fecha o número de movimiento.`}</span>
                            </p>
                            <div className='flex space-x-10'>
                                <div className='flex items-center space-x-2'>
                                    <Select placeholder='Saldo' value={foTipoSal} style={{ width: 140 }} onChange={(v) => setFoTipoSal(v || null)}>
                                        {
                                            tiposSal.map(({ codigo, nombre }) => (
                                                <Select.Option key={codigo} value={codigo}>{nombre}</Select.Option>
                                            ))
                                        }
                                    </Select>
                                    {
                                        foTipoSal === '1' &&
                                        <Tooltip title={ordenMov ? "Ordenar por número" : "Ordenar por fecha"}>
                                            <div className='ant-switch-titania'>
                                                <Switch checkedChildren={<AppleOutlined />} unCheckedChildren={<AndroidOutlined />}
                                                    checked={ordenMov} onChange={setOrdenMov} />
                                            </div>
                                        </Tooltip>
                                    }
                                    {foTipoSal === '1' && <DatePicker placeholder='Fecha inicio' value={foFechaIni} onChange={(d,) => setFoFechaIni(d || null)} />}
                                    {foTipoSal === '1' && <DatePicker placeholder='Fecha fin' value={foFechaFin} onChange={(d,) => setFoFechaFin(d || null)} />}
                                    {foTipoSal !== '1' && <DatePicker placeholder='Fecha' value={foFecha} onChange={(d,) => setFoFecha(d || null)} />}
                                    {
                                        foTipoSal !== '4' &&
                                        <div className='hidden lg:flex lg:items-center lg:space-x-2'>
                                            {
                                                (foTipoSal === '1' || foTipoSal === '2') &&
                                                (
                                                    loadConfigRT ?
                                                        <svg aria-hidden="true" role="status" className="inline mr-2 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#00008B" />
                                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                                                        </svg> :
                                                        <Select placeholder='Tipo Doc.' value={foTipoDoc} allowClear style={{ width: 160 }} onChange={(v) => setFoTipoDoc(v || null)}>
                                                            {
                                                                tiposDoc.map(({ codigo, nombre }) => (
                                                                    <Select.Option key={codigo} value={codigo}>{nombre}</Select.Option>
                                                                ))
                                                            }
                                                        </Select>
                                                )
                                            }
                                            {
                                                foTipoSal === '1' &&
                                                <Select placeholder='Tipo Mov.' value={foTipoMov} allowClear style={{ width: 130 }} onChange={(v) => setFoTipoMov(v || null)}>
                                                    {
                                                        tiposMov.map(({ codigo, nombre }) => (
                                                            <Select.Option key={codigo} value={codigo}>{nombre}</Select.Option>
                                                        ))
                                                    }
                                                </Select>
                                            }
                                            <Input placeholder="Rindente" value={foRindente} style={{ width: 200 }} onChange={(e) => setFoRindente(e.target.value)} />
                                        </div>
                                    }
                                    {
                                        !loadData ?
                                            <Tooltip title={foTipoSal === '1' ? "Buscar movimiento" : "Buscar saldo"}>
                                                <Button type="primary" shape="circle" icon={<SearchOutlined />} onClick={() => { if (foTipoSal === '1') handleBuscarMV(true); else handleBuscarSD(foTipoSal); }} />
                                            </Tooltip> :
                                            <Button type="primary" shape="circle" icon={<ZoomOutOutlined />} />
                                    }
                                </div>
                                {
                                    foTipoSal === '1' &&
                                    <div className='flex items-center space-x-2'>
                                        <Input placeholder="Nº de movimiento" style={{ width: 150 }} onChange={(e) => setFoNumMV(e.target.value)} />
                                        {
                                            !loadData ?
                                                <Tooltip title="Buscar movimiento">
                                                    <Button type="primary" shape="circle" icon={<SearchOutlined />} onClick={() => handleBuscarMV(false)} />
                                                </Tooltip> :
                                                <Button type="primary" shape="circle" icon={<ZoomOutOutlined />} />
                                        }
                                    </div>
                                }
                            </div>

                            <div className='lg:max-w-7xl'>
                                {
                                    loadBusqMov ?
                                        <div className='my-5 flex justify-center'>
                                            <Spin tip='Loading....' size='large' />
                                        </div> :
                                        foTipoSal === '1' ?
                                            <>
                                                <div className='mt-3 ant-table-titania ant-table-rowsel-titania ant-table-fnconmov'>
                                                    <Table
                                                        rowSelection={rowSelection}
                                                        columns={mvColumns}
                                                        dataSource={movimientos}
                                                        pagination={false}
                                                        scroll={{ y: 400 }}
                                                        bordered
                                                        size='small'
                                                    />
                                                </div>
                                                <div className='mt-2 flex justify-end ant-pagination-titania'>
                                                    <Pagination
                                                        defaultCurrent={mvCurrentPage}
                                                        total={mvTotalDocuments}
                                                        showSizeChanger
                                                        showTotal={(total, range) => `${range[0]}-${range[1]} de ${total} movimientos`}
                                                        defaultPageSize={mvPageSize}
                                                        onChange={handleChangePagMV}
                                                        onShowSizeChange={(_, size) => setMvPageSize(size)}
                                                        disabled={loadData} />
                                                </div>
                                            </> :
                                            <div className={'ant-table-titania ant-table-rowsel-titania ant-pagination-titania mt-3' + (foTipoSal === '2' ? ' w-[60rem]' : (foTipoSal === '3' ? ' w-[50rem]' : ' w-[35rem]'))}>
                                                <Table
                                                    rowSelection={rowSelection}
                                                    columns={foTipoSal === '2' ? sdColumns : (foTipoSal === '3' ? srColumns : stColumns)}
                                                    dataSource={foTipoSal === '2' ? saldosDoc : (foTipoSal === '3' ? saldosRin : saldosTpo)}
                                                    pagination={{
                                                        showSizeChanger: true,
                                                        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
                                                    }}
                                                    showSizeChanger
                                                    scroll={{ y: 400 }}
                                                    bordered
                                                    size='small'
                                                />
                                            </div>
                                }
                            </div>
                        </div>
                    </div>
            }
            <div className='w-full'>
                <AppFooter />
            </div>
        </div>
    )
}
